var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureIconwithcircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#2C2C2C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_4953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5 23.5H34L31.75 20.5L29.5 23.5ZM29.5 26.5H34L31.75 29.5L29.5 26.5Z",
    fill: "#5667FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.75 16H21.25V34H16.75C16.5511 34 16.3603 33.921 16.2197 33.7803C16.079 33.6397 16 33.4489 16 33.25V16.75C16 16.5511 16.079 16.3603 16.2197 16.2197C16.3603 16.079 16.5511 16 16.75 16Z",
    fill: "#5667FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.75 16H27.25C27.4489 16 27.6397 16.079 27.7803 16.2197C27.921 16.3603 28 16.5511 28 16.75V33.25C28 33.4489 27.921 33.6397 27.7803 33.7803C27.6397 33.921 27.4489 34 27.25 34H22.75V16Z",
    fill: "#FF6250"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_4953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIconwithcircle);
export default __webpack_public_path__ + "static/media/Feature Icon with circle.b6197b51a9ff2621d93def2ff7d439e3.svg";
export { ForwardRef as ReactComponent };